// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3TbwM","assignButton":"CreateEditEquipmentSchedule_assignButton__3zNh6"};